export default __webpack_public_path__ + "static/media/morpheus.2cd20da1.svg";